import ScrollMagic from 'ScrollMagic';
import 'debug.addIndicators';

var controller = new ScrollMagic.Controller();


function getAbsoluteBoundingRect(el) {
    var doc  = document,
        win  = window,
        body = doc.body,

        // pageXOffset and pageYOffset work everywhere except IE <9.
        offsetX = win.pageXOffset !== undefined ? win.pageXOffset :
            (doc.documentElement || body.parentNode || body).scrollLeft,
        offsetY = win.pageYOffset !== undefined ? win.pageYOffset :
            (doc.documentElement || body.parentNode || body).scrollTop,

        rect = el.getBoundingClientRect();

    if (el !== body) {
        var parent = el.parentNode;

        // The element's rect will be affected by the scroll positions of
        // *all* of its scrollable parents, not just the window, so we have
        // to walk up the tree and collect every scroll offset. Good times.
        while (parent !== body) {
            offsetX += parent.scrollLeft;
            offsetY += parent.scrollTop;
            parent   = parent.parentNode;
        }
    }

    return {
        bottom: rect.bottom + offsetY,
        height: rect.height,
        left  : rect.left + offsetX,
        right : rect.right + offsetX,
        top   : rect.top + offsetY,
        width : rect.width
    };
}

var initScrollMagic = function() {

    jQuery( window ).load(function() {

        setTimeout(function() {

            var $lines = jQuery('.line-trigger');
            var total = $lines.length;

            var linesWithPseudoEl = [];
        
            if (total > 1) {

                $lines.each(function(i, el) {
    
                    linesWithPseudoEl.push(el);
        
                    if (i !== total - 1) {
                        var prevElBottom = getAbsoluteBoundingRect($lines[i]).bottom;
                        var nextElTop = getAbsoluteBoundingRect($lines[i + 1]).top;
                        var newHeight = nextElTop - prevElBottom;
    
                        var $pseudoLine = jQuery("<div>", {
                            'data-class' : "menu--color-transparent",
                            css: {
                                "position": "absolute",
                                "top": prevElBottom,
                                "height" : newHeight,
                                "z-index" : "-1"
                            }
                        }).appendTo('.barba-container');
        
                        linesWithPseudoEl.push($pseudoLine[0]);
                    }
                });
            } else {
                $lines.each(function(i, el) {
                    linesWithPseudoEl.push(el);
                });
            }
    
            linesWithPseudoEl.forEach(function(el, i) {
                
                var className = jQuery(el).data('class');
                var height = jQuery(el).outerHeight();
                var offset = -58 - 20;
    
                if (i == 0) {
                    offset = 0;
                    height = height - 58 - 20; 
                }
    
                new ScrollMagic.Scene({triggerElement: el, duration: height, triggerHook: 'onLeave', offset: offset})
                    .setPin('.menu-wrapper')
                    .setClassToggle('.menu', className)
                    .addTo(controller);
            });

        }, 600);

    });
}

initScrollMagic();